import useProductFilterCount from '../../../queries/useProductFilterCount';

const useTireCommonFilterValues = () => {
    const { productFilterValues: PIM_ATT_APPLICATION_RANGE } =
        useProductFilterCount({
            filterField: 'PIM_ATT_APPLICATION_RANGE',
        });

    const { productFilterValues: PIM_ATT_ERP_MANUFACTURER } =
        useProductFilterCount({
            filterField: 'PIM_ATT_ERP_MANUFACTURER',
        });

    const { productFilterValues: PIM_ATT_LOAD_INDEX } = useProductFilterCount({
        filterField: 'PIM_ATT_LOAD_INDEX',
    });
    const { productFilterValues: PIM_ATT_SPEEDINDEX } = useProductFilterCount({
        filterField: 'PIM_ATT_SPEEDINDEX',
    });

    return {
        PIM_ATT_APPLICATION_RANGE,
        PIM_ATT_LOAD_INDEX,
        PIM_ATT_SPEEDINDEX,
        PIM_ATT_ERP_MANUFACTURER,
    };
};

export default useTireCommonFilterValues;
